import React, { useState, useEffect } from 'react';
import { Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import { ExpandMore } from '@mui/icons-material';

const SearchBar = ({ children = null, text = '', defaultOpen = false, style = {}, disabled = false, forceOpen = false, openBackgroundColor = '#ebf3f5' }) => {
  const [over, setOver] = useState(false);
  const [expanded, setExpanded] = useState(defaultOpen);
  const haveText = text.length > 0;
  const backgroundColor = (expanded || forceOpen) ? openBackgroundColor : 'white';
  useEffect(() => {
    if (forceOpen)setExpanded(true);
  }, [forceOpen]);

  return (
    <Accordion
      style={{
        width: '98%',
        borderRadius: 8,
        border: 'solid',
        borderWidth: over ? 2 : 1,
        borderColor: over ? '#046860' : 'black',
        boxShadow: '0px 6px 10px -2px rgba(67, 67, 75, 0.2)',
        backgroundColor,
        ...style,
      }}
      elevation={0}
      expanded={forceOpen || expanded}
      disabled={disabled}
    >
      <AccordionSummary
        expandIcon={<ExpandMore style={{ color: over ? '#046860' : '' }} />}
        onClick={forceOpen ? () => {} : () => setExpanded(!expanded)}
        onMouseOver={() => setOver(true)}
        onMouseOut={() => setOver(false)}
      >
        {!haveText && <div style={{ fontWeight: 500, color: (expanded || forceOpen) ? '#8c8c8c' : 'black', width: '100%' }}>{(expanded || forceOpen) ? '隱藏' : '擴展'}</div>}
        {haveText && <div style={{ fontWeight: 500, fontSize: 18, color: '#046860' }}>{text}</div>}
      </AccordionSummary>
      <AccordionDetails style={{ display: 'flex', flexDirection: 'column', marginBottom: 8, backgroundColor }}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

export default SearchBar;
